var HttpConfig = {
    TiMEOUT: 50000,//axios默认超时时间
    COOKIE: true, //axios是否携带cookies
    //以下为错误状态码
    USER_CODE: 401,
    LICENSE_CODE: 403,
    //以下为错误状态处理
    USER_UNAUTHORIZED: "unauthorized", //用户未授权
    USER_LOCKED: "user_lock", //用户锁定
    USER_NO_PERMISSION: "no_permission", //用户权限不足
    USER_CHANGE_PWD: "change_pwd", //用户需要更改密码
    USER_CHANGE_PERMISSION: "change_permission", //用户权限发生变化
    USER_EXPIRED: "user_expired", //用户账号失效，
    LICENSE_EXPIRED: "unlicensed", //系统未授权
}

export {HttpConfig}